// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/environment_secrets.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_audit } from "../../auth/v1/audit_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import { file_chalk_utils_v1_sensitive } from "../../utils/v1/sensitive_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/environment_secrets.proto.
 */
export const file_chalk_server_v1_environment_secrets: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_audit, file_chalk_auth_v1_permissions, file_chalk_utils_v1_sensitive, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.Secret
 */
export type Secret = Message<"chalk.server.v1.Secret"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string integration_id = 4;
   */
  integrationId?: string;

  /**
   * @generated from field: chalk.server.v1.SecretSource source = 5;
   */
  source: SecretSource;

  /**
   * Owning scope. Unset means the secret is environment-wide.
   *
   * @generated from field: optional chalk.server.v1.SecretScope scope = 6;
   */
  scope?: SecretScope;

  /**
   * Scopes this environment-wide secret has been granted to by reference.
   * Populated only when ListSecretsRequest.include_scoped is set.
   *
   * @generated from field: repeated chalk.server.v1.SecretScope granted_scopes = 7;
   */
  grantedScopes: SecretScope[];
};

/**
 * Describes the message chalk.server.v1.Secret.
 * Use `create(SecretSchema)` to create a new message.
 */
export const SecretSchema: GenMessage<Secret> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 0);

/**
 * Consumer a secret is owned by or granted to. Secrets owned by a
 * non-ENVIRONMENT scope are invisible to environment-wide consumers.
 *
 * @generated from message chalk.server.v1.SecretScope
 */
export type SecretScope = Message<"chalk.server.v1.SecretScope"> & {
  /**
   * @generated from field: chalk.server.v1.SecretScopeType type = 1;
   */
  type: SecretScopeType;

  /**
   * Required for every type except ENVIRONMENT, which must leave it empty.
   *
   * @generated from field: optional string ref = 2;
   */
  ref?: string;
};

/**
 * Describes the message chalk.server.v1.SecretScope.
 * Use `create(SecretScopeSchema)` to create a new message.
 */
export const SecretScopeSchema: GenMessage<SecretScope> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 1);

/**
 * @generated from message chalk.server.v1.SecretValue
 */
export type SecretValue = Message<"chalk.server.v1.SecretValue"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: chalk.server.v1.SecretSource source = 3;
   */
  source: SecretSource;
};

/**
 * Describes the message chalk.server.v1.SecretValue.
 * Use `create(SecretValueSchema)` to create a new message.
 */
export const SecretValueSchema: GenMessage<SecretValue> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 2);

/**
 * @generated from message chalk.server.v1.SecretConfigValue
 */
export type SecretConfigValue = Message<"chalk.server.v1.SecretConfigValue"> & {
  /**
   * @generated from oneof chalk.server.v1.SecretConfigValue.value
   */
  value: {
    /**
     * @generated from field: string literal = 1;
     */
    value: string;
    case: "literal";
  } | {
    /**
     * @generated from field: string secret_id = 2;
     */
    value: string;
    case: "secretId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.SecretConfigValue.
 * Use `create(SecretConfigValueSchema)` to create a new message.
 */
export const SecretConfigValueSchema: GenMessage<SecretConfigValue> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 3);

/**
 * @generated from message chalk.server.v1.SecretWithValue
 */
export type SecretWithValue = Message<"chalk.server.v1.SecretWithValue"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName: string;

  /**
   * @generated from field: optional string value = 5;
   */
  value?: string;

  /**
   * @generated from field: chalk.server.v1.SecretSource source = 6;
   */
  source: SecretSource;
};

/**
 * Describes the message chalk.server.v1.SecretWithValue.
 * Use `create(SecretWithValueSchema)` to create a new message.
 */
export const SecretWithValueSchema: GenMessage<SecretWithValue> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 4);

/**
 * @generated from message chalk.server.v1.ListSecretsRequest
 */
export type ListSecretsRequest = Message<"chalk.server.v1.ListSecretsRequest"> & {
  /**
   * Also return scope-owned secrets (with Secret.scope set) and populate
   * Secret.granted_scopes on environment-wide secrets. Defaults to false so
   * existing consumers keep seeing only environment-wide secrets.
   *
   * @generated from field: bool include_scoped = 1;
   */
  includeScoped: boolean;
};

/**
 * Describes the message chalk.server.v1.ListSecretsRequest.
 * Use `create(ListSecretsRequestSchema)` to create a new message.
 */
export const ListSecretsRequestSchema: GenMessage<ListSecretsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 5);

/**
 * @generated from message chalk.server.v1.ListSecretsResponse
 */
export type ListSecretsResponse = Message<"chalk.server.v1.ListSecretsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.Secret secrets = 1;
   */
  secrets: Secret[];
};

/**
 * Describes the message chalk.server.v1.ListSecretsResponse.
 * Use `create(ListSecretsResponseSchema)` to create a new message.
 */
export const ListSecretsResponseSchema: GenMessage<ListSecretsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 6);

/**
 * @generated from message chalk.server.v1.GetSecretValueRequest
 */
export type GetSecretValueRequest = Message<"chalk.server.v1.GetSecretValueRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.GetSecretValueRequest.
 * Use `create(GetSecretValueRequestSchema)` to create a new message.
 */
export const GetSecretValueRequestSchema: GenMessage<GetSecretValueRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 7);

/**
 * @generated from message chalk.server.v1.GetSecretValueResponse
 */
export type GetSecretValueResponse = Message<"chalk.server.v1.GetSecretValueResponse"> & {
  /**
   * @generated from field: optional chalk.server.v1.SecretValue secret_value = 1;
   */
  secretValue?: SecretValue;
};

/**
 * Describes the message chalk.server.v1.GetSecretValueResponse.
 * Use `create(GetSecretValueResponseSchema)` to create a new message.
 */
export const GetSecretValueResponseSchema: GenMessage<GetSecretValueResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 8);

/**
 * @generated from message chalk.server.v1.UpsertSecretRequest
 */
export type UpsertSecretRequest = Message<"chalk.server.v1.UpsertSecretRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string value = 2 [deprecated = true];
   * @deprecated
   */
  value: string;

  /**
   * @generated from field: chalk.server.v1.SecretConfigValue config = 3;
   */
  config?: SecretConfigValue;

  /**
   * Omitted/ENVIRONMENT: environment-wide upsert. Non-ENVIRONMENT with a
   * config/value: upsert a secret owned by that scope; names are unique per
   * scope. Non-ENVIRONMENT without config/value: grant the environment-wide
   * secret with this name to the scope by reference (NOT_FOUND if absent).
   *
   * @generated from field: optional chalk.server.v1.SecretScope scope = 4;
   */
  scope?: SecretScope;
};

/**
 * Describes the message chalk.server.v1.UpsertSecretRequest.
 * Use `create(UpsertSecretRequestSchema)` to create a new message.
 */
export const UpsertSecretRequestSchema: GenMessage<UpsertSecretRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 9);

/**
 * @generated from message chalk.server.v1.UpsertSecretResponse
 */
export type UpsertSecretResponse = Message<"chalk.server.v1.UpsertSecretResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.Secret secrets = 1;
   */
  secrets: Secret[];
};

/**
 * Describes the message chalk.server.v1.UpsertSecretResponse.
 * Use `create(UpsertSecretResponseSchema)` to create a new message.
 */
export const UpsertSecretResponseSchema: GenMessage<UpsertSecretResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 10);

/**
 * @generated from message chalk.server.v1.DeleteSecretRequest
 */
export type DeleteSecretRequest = Message<"chalk.server.v1.DeleteSecretRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Omitted/ENVIRONMENT: queue the environment-wide secret for deletion.
   * Non-ENVIRONMENT: delete the scope's own secret with this name, or if it
   * has none, revoke the scope's grant on the environment-wide secret.
   *
   * @generated from field: optional chalk.server.v1.SecretScope scope = 2;
   */
  scope?: SecretScope;
};

/**
 * Describes the message chalk.server.v1.DeleteSecretRequest.
 * Use `create(DeleteSecretRequestSchema)` to create a new message.
 */
export const DeleteSecretRequestSchema: GenMessage<DeleteSecretRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 11);

/**
 * @generated from message chalk.server.v1.DeleteSecretResponse
 */
export type DeleteSecretResponse = Message<"chalk.server.v1.DeleteSecretResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.Secret secrets = 1;
   */
  secrets: Secret[];
};

/**
 * Describes the message chalk.server.v1.DeleteSecretResponse.
 * Use `create(DeleteSecretResponseSchema)` to create a new message.
 */
export const DeleteSecretResponseSchema: GenMessage<DeleteSecretResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 12);

/**
 * @generated from message chalk.server.v1.GetAllSecretValuesRequest
 */
export type GetAllSecretValuesRequest = Message<"chalk.server.v1.GetAllSecretValuesRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetAllSecretValuesRequest.
 * Use `create(GetAllSecretValuesRequestSchema)` to create a new message.
 */
export const GetAllSecretValuesRequestSchema: GenMessage<GetAllSecretValuesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 13);

/**
 * @generated from message chalk.server.v1.GetAllSecretValuesResponse
 */
export type GetAllSecretValuesResponse = Message<"chalk.server.v1.GetAllSecretValuesResponse"> & {
  /**
   * Secret name -> plaintext value, for every active environment-wide
   * secret in the current environment (scope-owned secrets are excluded).
   * Used by the engine at startup to populate the process-global map that
   * backs `F.read_secret(name)`.
   *
   * @generated from field: map<string, string> values = 1;
   */
  values: { [key: string]: string };
};

/**
 * Describes the message chalk.server.v1.GetAllSecretValuesResponse.
 * Use `create(GetAllSecretValuesResponseSchema)` to create a new message.
 */
export const GetAllSecretValuesResponseSchema: GenMessage<GetAllSecretValuesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment_secrets, 14);

/**
 * @generated from enum chalk.server.v1.SecretScopeType
 */
export enum SecretScopeType {
  /**
   * @generated from enum value: SECRET_SCOPE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SECRET_SCOPE_TYPE_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * @generated from enum value: SECRET_SCOPE_TYPE_SANDBOX = 2;
   */
  SANDBOX = 2,

  /**
   * @generated from enum value: SECRET_SCOPE_TYPE_SCALING_GROUP = 3;
   */
  SCALING_GROUP = 3,

  /**
   * @generated from enum value: SECRET_SCOPE_TYPE_FUNCTION = 4;
   */
  FUNCTION = 4,

  /**
   * @generated from enum value: SECRET_SCOPE_TYPE_NOTEBOOK = 5;
   */
  NOTEBOOK = 5,
}

/**
 * Describes the enum chalk.server.v1.SecretScopeType.
 */
export const SecretScopeTypeSchema: GenEnum<SecretScopeType> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment_secrets, 0);

/**
 * @generated from enum chalk.server.v1.SecretSource
 */
export enum SecretSource {
  /**
   * @generated from enum value: SECRET_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SECRET_SOURCE_MANAGED = 1;
   */
  MANAGED = 1,

  /**
   * @generated from enum value: SECRET_SOURCE_EXTERNAL = 2;
   */
  EXTERNAL = 2,
}

/**
 * Describes the enum chalk.server.v1.SecretSource.
 */
export const SecretSourceSchema: GenEnum<SecretSource> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment_secrets, 1);

/**
 * @generated from service chalk.server.v1.EnvironmentSecretsService
 */
export const EnvironmentSecretsService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.EnvironmentSecretsService.ListSecrets
   */
  listSecrets: {
    methodKind: "unary";
    input: typeof ListSecretsRequestSchema;
    output: typeof ListSecretsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentSecretsService.GetSecretValue
   */
  getSecretValue: {
    methodKind: "unary";
    input: typeof GetSecretValueRequestSchema;
    output: typeof GetSecretValueResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentSecretsService.GetAllSecretValues
   */
  getAllSecretValues: {
    methodKind: "unary";
    input: typeof GetAllSecretValuesRequestSchema;
    output: typeof GetAllSecretValuesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentSecretsService.UpsertSecret
   */
  upsertSecret: {
    methodKind: "unary";
    input: typeof UpsertSecretRequestSchema;
    output: typeof UpsertSecretResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentSecretsService.DeleteSecret
   */
  deleteSecret: {
    methodKind: "unary";
    input: typeof DeleteSecretRequestSchema;
    output: typeof DeleteSecretResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_environment_secrets, 0);

